(function($) {

    $( document ).ready(function() {
        $( document ).on( "click", ".collection-tag-filters ul li", function() {
            var name = $(this).data('name')
            var url = $(this).data('url')

            $('.collection-tag-filters ul li').each(function() {
                $(this).removeClass('active')
            })
            $(this).addClass('active')

            ajaxfilter(url)
        });

        var homeSliders = $('.template-index .slideshow.flickity-enabled');

        if (homeSliders) {
          $( homeSliders ).each(function( index, elem ) {
            setTimeout(function(){
              $(elem).flickity('resize');
            }, 2000)
          });
        }


        $( document ).on( "click", ".StockNotify", function() {
            $('.stock-notify-popup').show();
            $('.stock-notify-form').show();
            $('.stock-notify-popup').find('.success-message').hide();
        });

        $( document ).on( "submit", ".stock-notify-form", function(e) {

            e.preventDefault()

            $(this).find('.btn').css('font-size', 0);
            $(this).find('.loading-overlay__spinner').show();
            
            let data = {
                event: 'in_stock_notify',
                product_name: $(this).find('input[name=product-name]').val()  ,
                size: $(this).find('select[name=product-variation] option:selected').val(),
                email: $(this).find('input[name=name]').val(),
                name: $(this).find('input[name=email]').val()
            }

            dataLayer.push(data);

            setTimeout(function() {
                $('.stock-notify-form').find('.btn').css('font-size', '13px');
                $('.stock-notify-form').find('.loading-overlay__spinner').hide();
                $('.stock-notify-form').hide();
                $('.stock-notify-popup').find('.success-message').css('display', 'flex');
            }, 1000)

            return false;
            
        });

        $( document ).on( "click", ".close-popup", function(e) {
            $('.stock-notify-popup').hide();
        });

        $( document ).on( "click", ".swatch-element", function(e) {
            
            if ( $(this).hasClass('soldout') ) {
                $('.StockNotify.btn').show();
            } else {
                $('.StockNotify.btn').hide();
            }

            let val = $(this).data('value')
            $('.stock-notify-form select[name=product-variation] option').attr('selected', false);
            $('.stock-notify-form select option[value='+val+']').attr('selected', true);

        });


        var swiper = new Swiper(".mySwiper", {
            lazy: true
        });

        var swiper = new Swiper(".announcement-swiper", {
             autoplay: {
                delay: 5000,
              },
        });

        

        function adjustVideoHeight() {
            $( '.grid-products .gview-img' ).each(function( index ) {
                let height = $(this).find('img').height();

                if (height > 0) {
                    $('.product-video').attr('height', height);

                    let swiper = $(this).find('.mySwiper')[0].swiper
                    swiper.slideNext();

                    setTimeout(function() {
                        swiper.slidePrev();
                    }, 800)

                    return false;
                } 
                
            });
        }
        
        $(window).resize(function(){
           adjustVideoHeight();
           console.log('adjusted video height')
        });

        adjustVideoHeight();

    });

})(jQuery);